import {
  combineReducers,
  configureStore,
  PreloadedState,
} from '@reduxjs/toolkit';
import { throttle } from 'lodash-es';
import { useDispatch } from 'react-redux';

import account from './account';
import kits from './kits';
import modal from './modal';
import user from './user';
// import features from './features';
import agreements from './agreements';
import banners from './banners';
import home from './home';
import table from './table';
import ui from './ui';

const saveState = (state: Partial<RootState>) => {
  const serializedState = JSON.stringify(state);
  localStorage.setItem('root', serializedState);
};

const reHydrateStore = () => {
  const root = localStorage.getItem('root');
  if (root) {
    return JSON.parse(root);
  }
};

const rootReducer = combineReducers({
  user,
  kits,
  account,
  modal,
  // features,
  ui,
  home,
  table,
  agreements,
  banners,
});

export const initStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState: preloadedState || reHydrateStore(),
  });
};

const store = initStore();

// on updates to the store, persist some parts to localStorage
// no more than once per second
store.subscribe(
  throttle(
    () =>
      saveState({
        user: store.getState().user,
        kits: store.getState().kits,
        modal: store.getState().modal,
        agreements: store.getState().agreements,
        banners: store.getState().banners,
      }),
    1000,
  ),
);

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof initStore>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
